const HomeIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M20.25 10.9397V20.25H14.25V14.25H9.75V20.25H3.75V10.9397L11.4694 3.21935C11.539 3.14962 11.6217 3.0943 11.7128 3.05656C11.8038 3.01882 11.9014 2.99939 12 2.99939C12.0986 2.99939 12.1962 3.01882 12.2872 3.05656C12.3783 3.0943 12.461 3.14962 12.5306 3.21935L20.25 10.9397Z'
                fill='#827CA8'
            />
            <path
                d='M22.5 19.5H21V12.75L21.2194 12.9694C21.3604 13.1101 21.5515 13.1891 21.7507 13.1889C21.9499 13.1887 22.1408 13.1094 22.2816 12.9684C22.4223 12.8275 22.5013 12.6363 22.5011 12.4371C22.5009 12.2379 22.4216 12.047 22.2806 11.9062L13.0603 2.68875C12.779 2.40766 12.3977 2.24976 12 2.24976C11.6023 2.24976 11.221 2.40766 10.9397 2.68875L1.71938 11.9062C1.57877 12.047 1.49983 12.2378 1.49991 12.4367C1.5 12.6357 1.57911 12.8264 1.71984 12.967C1.86057 13.1076 2.0514 13.1866 2.25033 13.1865C2.44927 13.1864 2.64002 13.1073 2.78062 12.9666L3 12.75V19.5H1.5C1.30109 19.5 1.11032 19.579 0.96967 19.7197C0.829018 19.8603 0.75 20.0511 0.75 20.25C0.75 20.4489 0.829018 20.6397 0.96967 20.7803C1.11032 20.921 1.30109 21 1.5 21H22.5C22.6989 21 22.8897 20.921 23.0303 20.7803C23.171 20.6397 23.25 20.4489 23.25 20.25C23.25 20.0511 23.171 19.8603 23.0303 19.7197C22.8897 19.579 22.6989 19.5 22.5 19.5ZM4.5 11.25L12 3.75L19.5 11.25V19.5H15V14.25C15 14.0511 14.921 13.8603 14.7803 13.7197C14.6397 13.579 14.4489 13.5 14.25 13.5H9.75C9.55109 13.5 9.36032 13.579 9.21967 13.7197C9.07902 13.8603 9 14.0511 9 14.25V19.5H4.5V11.25ZM13.5 19.5H10.5V15H13.5V19.5Z'
                fill='#827CA8'
            />
        </svg>
    );
};

export default HomeIcon;
